export const DEFAULT_ACTIONS_PAGE_SIZE = 100;

export const defaultRequestParams = {
  page_size: String(DEFAULT_ACTIONS_PAGE_SIZE),
};
